module.exports = __webpack_public_path__ + "img/744.c25ad944.jpg";